{
  "copy_experience": {
    "tooltip": "Copy experience",
    "success_toast_title": "Experience copied!",
    "success_toast_description": "A copy of this experience has been created in your account",
    "error_toast": "Error copying experience"
  }
}
